<template>
  <div class="max-w-5xl mx-auto">
    <!-- 页面标题 -->
    <div class="text-center mb-12">
      <h1 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-neutral-800 mb-4">联系我们</h1>
      <p class="text-neutral-500 max-w-2xl mx-auto">如果您有任何问题或建议，欢迎通过以下方式联系我们</p>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
      <!-- 联系方式 -->
      <div class="bg-white rounded-lg shadow-elevation-1 p-8">
        <h2 class="text-xl font-semibold mb-6 flex items-center">
          <i class="fa fa-phone-square text-primary mr-3 text-2xl"></i>
          联系方式
        </h2>

        <div class="space-y-6">
          <div class="flex items-start">
            <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary mr-4 flex-shrink-0">
              <i class="fa fa-headphones text-xl"></i>
            </div>
            <div>
              <h3 class="font-medium mb-1">客服热线</h3>
              <p class="text-neutral-600 mb-1">400-123-4567</p>
              <p class="text-sm text-neutral-500">工作时间：9:00 - 22:00（全年无休）</p>
            </div>
          </div>

          <div class="flex items-start">
            <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary mr-4 flex-shrink-0">
              <i class="fa fa-envelope text-xl"></i>
            </div>
            <div>
              <h3 class="font-medium mb-1">客服邮箱</h3>
              <p class="text-neutral-600 mb-1">service@eliteshop.com</p>
              <p class="text-sm text-neutral-500">24小时内回复</p>
            </div>
          </div>

          <div class="flex items-start">
            <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary mr-4 flex-shrink-0">
              <i class="fa fa-map-marker text-xl"></i>
            </div>
            <div>
              <h3 class="font-medium mb-1">公司地址</h3>
              <p class="text-neutral-600 mb-1">北京市朝阳区建国路88号 Elite大厦 18层</p>
              <p class="text-sm text-neutral-500">来访请提前预约</p>
            </div>
          </div>

          <div class="flex items-start">
            <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary mr-4 flex-shrink-0">
              <i class="fa fa-weixin text-xl"></i>
            </div>
            <div>
              <h3 class="font-medium mb-1">微信客服</h3>
              <div class="flex items-center">
                <img src="https://picsum.photos/100/100?random=50" alt="微信客服二维码" class="w-24 h-24 rounded mr-4">
                <div class="text-neutral-600">
                  <p>扫码添加客服微信</p>
                  <p class="text-sm text-neutral-500">备注：咨询+您的姓名</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 社交媒体 -->
        <div class="mt-8">
          <h3 class="font-medium mb-4">关注我们</h3>
          <div class="flex space-x-4">
            <a href="#" class="w-10 h-10 rounded-full bg-[#07C160] flex items-center justify-center text-white hover:bg-[#06B058] transition-colors">
              <i class="fa fa-weixin"></i>
            </a>
            <a href="#" class="w-10 h-10 rounded-full bg-[#E6162D] flex items-center justify-center text-white hover:bg-[#D01429] transition-colors">
              <i class="fa fa-weibo"></i>
            </a>
            <a href="#" class="w-10 h-10 rounded-full bg-[#E4405F] flex items-center justify-center text-white hover:bg-[#D23A55] transition-colors">
              <i class="fa fa-instagram"></i>
            </a>
            <a href="#" class="w-10 h-10 rounded-full bg-[#1877F2] flex items-center justify-center text-white hover:bg-[#166FE5] transition-colors">
              <i class="fa fa-facebook"></i>
            </a>
            <a href="#" class="w-10 h-10 rounded-full bg-[#FF0000] flex items-center justify-center text-white hover:bg-[#E60000] transition-colors">
              <i class="fa fa-youtube-play"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- 联系表单 -->
      <div class="bg-white rounded-lg shadow-elevation-1 p-8">
        <h2 class="text-xl font-semibold mb-6 flex items-center">
          <i class="fa fa-paper-plane text-primary mr-3 text-2xl"></i>
          在线留言
        </h2>

        <form @submit.prevent="submitForm">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label class="block text-sm font-medium mb-1" for="name">姓名</label>
              <input v-model="form.name" type="text" id="name" class="w-full px-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary" placeholder="请输入您的姓名">
              <span v-if="errors.name" class="text-danger text-sm mt-1 block">{{ errors.name }}</span>
            </div>
            <div>
              <label class="block text-sm font-medium mb-1" for="phone">手机号码</label>
              <input v-model="form.phone" type="tel" id="phone" class="w-full px-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary" placeholder="请输入您的手机号码">
              <span v-if="errors.phone" class="text-danger text-sm mt-1 block">{{ errors.phone }}</span>
            </div>
          </div>

          <div class="mb-4">
            <label class="block text-sm font-medium mb-1" for="email">邮箱</label>
            <input v-model="form.email" type="email" id="email" class="w-full px-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary" placeholder="请输入您的邮箱地址">
            <span v-if="errors.email" class="text-danger text-sm mt-1 block">{{ errors.email }}</span>
          </div>

          <div class="mb-4">
            <label class="block text-sm font-medium mb-1" for="subject">问题类型</label>
            <select v-model="form.subject" id="subject" class="w-full px-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary">
              <option value="">请选择问题类型</option>
              <option value="order">订单咨询</option>
              <option value="product">商品咨询</option>
              <option value="payment">支付问题</option>
              <option value="delivery">配送问题</option>
              <option value="return">退换货</option>
              <option value="complaint">投诉建议</option>
              <option value="other">其他问题</option>
            </select>
            <span v-if="errors.subject" class="text-danger text-sm mt-1 block">{{ errors.subject }}</span>
          </div>

          <div class="mb-6">
            <label class="block text-sm font-medium mb-1" for="message">留言内容</label>
            <textarea v-model="form.message" id="message" rows="5" class="w-full px-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary" placeholder="请详细描述您的问题或建议"></textarea>
            <span v-if="errors.message" class="text-danger text-sm mt-1 block">{{ errors.message }}</span>
          </div>

          <div class="mb-6">
            <label class="flex items-center cursor-pointer">
              <input type="checkbox" v-model="form.agreement" class="mr-2">
              <span class="text-sm">我同意 EliteShop 按照<a href="/privacy-policy" class="text-primary hover:underline">《隐私政策》</a>处理我的个人信息</span>
            </label>
            <span v-if="errors.agreement" class="text-danger text-sm mt-1 block">{{ errors.agreement }}</span>
          </div>

          <button type="submit" class="w-full bg-primary hover:bg-primary/90 text-white font-medium py-3 px-4 rounded-lg transition-colors" :disabled="loading">
            <i v-if="loading" class="fa fa-spinner fa-spin mr-2"></i>
            提交留言
          </button>
        </form>
      </div>
    </div>

    <!-- 常见问题 -->
    <div class="bg-white rounded-lg shadow-elevation-1 p-8">
      <h2 class="text-xl font-semibold mb-6">常见问题</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="border-b border-neutral-200 pb-4">
          <h3 class="font-medium mb-2">如何查询订单状态？</h3>
          <p class="text-neutral-600 text-sm">您可以在"我的订单"中查看所有订单的实时状态，包括待付款、待发货、已发货、已完成等。</p>
        </div>
        <div class="border-b border-neutral-200 pb-4">
          <h3 class="font-medium mb-2">忘记密码怎么办？</h3>
          <p class="text-neutral-600 text-sm">在登录页面点击"忘记密码"，通过绑定的手机号或邮箱接收验证码，重置密码即可。</p>
        </div>
        <div class="border-b border-neutral-200 pb-4">
          <h3 class="font-medium mb-2">如何修改收货地址？</h3>
          <p class="text-neutral-600 text-sm">在"我的账户-地址管理"中可以添加、修改、删除收货地址，并设置默认地址。</p>
        </div>
        <div class="border-b border-neutral-200 pb-4">
          <h3 class="font-medium mb-2">发票如何申请？</h3>
          <p class="text-neutral-600 text-sm">下单时可以选择开具发票，电子发票会发送到您的邮箱，纸质发票随商品一同寄出。</p>
        </div>
        <div class="border-b border-neutral-200 pb-4">
          <h3 class="font-medium mb-2">优惠券如何使用？</h3>
          <p class="text-neutral-600 text-sm">在结算页面可以选择使用优惠券，系统会自动抵扣相应金额，不同优惠券有不同使用规则。</p>
        </div>
        <div class="border-b border-neutral-200 pb-4">
          <h3 class="font-medium mb-2">商品保修政策？</h3>
          <p class="text-neutral-600 text-sm">数码产品全国联保1年，家电产品保修按国家三包政策执行，部分商品可购买延保服务。</p>
        </div>
      </div>
      <div class="mt-6 text-center">
        <router-link to="/faq" class="text-primary hover:underline inline-flex items-center">
          查看更多常见问题 <i class="fa fa-angle-right ml-1"></i>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        subject: '',
        message: '',
        agreement: false
      },
      errors: {},
      loading: false
    }
  },
  methods: {
    validateForm() {
      this.errors = {}
      
      if (!this.form.name) {
        this.errors.name = '请输入您的姓名'
      }
      
      if (!this.form.phone) {
        this.errors.phone = '请输入您的手机号码'
      } else if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.errors.phone = '请输入有效的手机号码'
      }
      
      if (!this.form.email) {
        this.errors.email = '请输入您的邮箱地址'
      } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.form.email)) {
        this.errors.email = '请输入有效的邮箱地址'
      }
      
      if (!this.form.subject) {
        this.errors.subject = '请选择问题类型'
      }
      
      if (!this.form.message) {
        this.errors.message = '请输入留言内容'
      } else if (this.form.message.length < 10) {
        this.errors.message = '留言内容至少10个字'
      }
      
      if (!this.form.agreement) {
        this.errors.agreement = '请同意隐私政策'
      }
      
      return Object.keys(this.errors).length === 0
    },
    submitForm() {
      if (!this.validateForm()) return
      
      this.loading = true
      
      // 模拟提交表单
      setTimeout(() => {
        this.loading = false
        this.$bus.$emit('showMessage', '留言提交成功！我们会尽快与您联系')
        
        // 重置表单
        this.form = {
          name: '',
          phone: '',
          email: '',
          subject: '',
          message: '',
          agreement: false
        }
      }, 1500)
    }
  }
}
</script>